module.exports = __webpack_public_path__ + "static/img/heroimage_send_large.a48be2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_send_large.png
// module id = 366
// module chunks = 1